export enum SPECIFIC_CHARTS {
  // Esses são os Códigos do Tipos dos Gráficos
  GOAL_EVOLUTION_MONTH_BY_MONTH = 4,
  GOAL_EVOLUTION_DAY_BY_DAY = 16,
  GOAL_EVOLUTION_DAY_BY_DAY_INVOICE = 20,
  GOAL_EVOLUTION_MONTH_BY_MONTH_INVOICE = 21,
  GOAL_EVOLUTION_DAY_BY_DAY_BIWEEKLY_INVOICE = 30,
  GOAL_EVOLUTION_DAY_BY_DAY_WEEKLY_INVOICE = 31,
}
